import { posthog } from "./posthog";

/**
 * Wrap posthog.capture so analytics failures never break a user flow.
 * Logs at warn level with the event name + context so issues are still
 * traceable without crashing the caller.
 */
export function safeCapture(
  event: string,
  props: Record<string, unknown>,
  logLabel = "analytics"
): void {
  try {
    posthog.capture(event, props);
  } catch (err) {
    console.warn(`[${logLabel}] posthog capture failed`, { event, err });
  }
}
